import {
  Icon,
  IconButton,
  IconButtonProps,
  ResponsiveValue,
  Tooltip,
} from '@chakra-ui/react'
import React from 'react'
import IconCallStart from '~/assets/svgs/icon-call-start.svg?react'
import IconCallStop from '~/assets/svgs/icon-call-stop.svg?react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { Size } from '~/types/ThemeTypes'

import {
  CallButtonVariants,
  useCallButtonStyles,
} from './componentStyles/CallButton.style'

const { Tooltip: TooltipColors } = themeColorSectionKeys.shared

type CallButtonProps = {
  variant: CallButtonVariants
  size?: ResponsiveValue<Size.sm | Size.md | Size.lg | Size.full>
  disabled?: boolean
  onClick?: () => void
} & Omit<IconButtonProps, 'aria-label' | 'onClick'>
export const CallButton = ({
  variant,
  size,
  disabled,
  onClick,
  ...rest
}: CallButtonProps) => {
  const styles = useCallButtonStyles({
    variant: disabled ? CallButtonVariants.Disabled : variant,
    size,
  })

  const getTooltipText = () => {
    switch (variant) {
      case CallButtonVariants.Start:
        return 'Start Call'
      case CallButtonVariants.Stop:
        return 'End Call'
      case CallButtonVariants.Disabled:
        return 'Disabled'
      default:
        return 'Unknown'
    }
  }
  const getIcon = () => {
    switch (variant) {
      case CallButtonVariants.Start:
        return <Icon as={IconCallStart} sx={styles.icon} />
      case CallButtonVariants.Stop:
        return <Icon as={IconCallStop} sx={styles.icon} />
    }
  }

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick()
    }
  }

  return (
    //TODO: There's a lot weirdness with the base Tooltip, we might want to wrap it into a custom component
    // 1) the display property doesn't work through __css, so we have to use sx
    // 2) coloring the background through sx (and __css) doesn't apply to the arrow for some reason
    <Tooltip
      sx={styles.tooltip}
      bg={TooltipColors.Background}
      color={TooltipColors.FontColor}
      hasArrow
      label={getTooltipText()}
    >
      <IconButton
        __css={styles.button}
        onClick={handleClick}
        aria-label={getTooltipText()}
        flexShrink="0"
        {...rest}
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  )
}
